module.exports = __webpack_public_path__ + "static/mastery_icon-9644aed6dac75e1fc6e1b9709143d79d.png";